import * as React from 'react';
import YesNoComponent from './YesNoComponent';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';

export interface PedalMarkingsProps {}

const PedalMarkings: React.FC<PedalMarkingsProps> = () => {
  const next = useNextStepAfterUpdate();
  const handleClick = (pedal: boolean) => {
    next({ pedal: !!pedal }, 'piano');
  };

  return <YesNoComponent handleClick={handleClick} id="pedal" />;
};

export default PedalMarkings;
